<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <div class="right pointer" v-if="getUser">
          <a v-on:click="signout"
            ><i class="fad fa-sign-out-alt"></i> {{ $t("SignOut") }}</a
          >
        </div>
        <div v-else>
          <router-link to="/signup" class="left">
            <i class="fad fa-user-plus"></i>
            {{ $t("Register") }}</router-link
          >
          <router-link to="/signin" class="right">
            <i class="fad fa-sign-in-alt"></i>
            {{ $t("Login") }}</router-link
          >
        </div>
        <span class="text-accent">{{ $t("Account") }} </span>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="view-header" v-if="getUser">
        <div class="pull-right text-right" style="line-height: 14px"></div>
        <div class="header-icon">
          <i class="fad fa-user-astronaut pe-7s-user"></i>
        </div>
        <div class="header-title">
          <h4 class="m-b-xs">{{ getUser.email }}</h4>
          <small> ID : {{ getUser._id }} </small><br />
        </div>
      </div>
      <nav id="nav">
        <ul class="nav">
          <li>
            <router-link to="/transfer">
              <i class="fad fa-exchange-alt"></i>
              {{ $t("Transfer") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/receive">
              <i class="fad fa-qrcode"></i>
              {{ $t("Receive") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
        </ul>
        <ul class="nav">
          <li>
            <router-link to="/transactions">
              <i class="fad fa-clipboard-list"></i>
              {{ $t("Transactions") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/deposithistory">
              <i class="fad fa-donate"></i>
              {{ $t("DepositHistory") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/withdrawhistory">
              <i class="fad fa-paper-plane"></i>
              {{ $t("WithdrawalHistory") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
        </ul>
        <ul class="nav">
          <li>
            <router-link to="/myinvest">
              <i class="fad fa-gift"></i>

              {{ $t("MyEarnings") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/affiliate">
              <i class="fad fa-sitemap"></i>
              {{ $t("AffiliateProgram") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
        </ul>
        <ul class="nav">
          <li>
            <router-link to="/security">
              <i class="fad fa-shield-alt"></i>
              {{ $t("Security") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/language">
              <i class="fad fa-language"></i>
              {{ $t("Language") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
        </ul>
        <ul class="nav">
          <li>
            <router-link to="/partner">
              <i class="fad fa-handshake"></i>
              {{ $t("OurPartners") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/support">
              <i class="fad fa-phone"></i>
              {{ $t("Support") }}
              <span class="nav-icon">
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/page">
              <i class="fad fa-code-branch"></i>
              {{ $t("About") }}
              <span class="nav-icon">
                V {{ version }}
                <i class="fad fa-chevron-right"></i>
              </span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { VERSION } from "../../config";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return { version: VERSION };
  },
  computed: mapGetters(["getUser"]),
  methods: {
    ...mapActions(["Logout"]),
    signout() {
      this.$socket.off("user.balance." + this.getUser._id);
      this.Logout();
    }
  }
};
</script>

<style scoped>
.nav a {
  color: #949ba2;
  background: #1d1f24;
  margin-bottom: 5px;
}
.nav > li > a:focus,
.nav > li > a:hover {
  text-decoration: none;
  background-color: #2c313c;
}
.nav {
  margin-bottom: 10px;
}
.nav-icon {
  float: right;
}
.fad {
  width: 22px;
}
.right {
  color: #f6a821;
}
.left {
  color: #f6a821;
}
</style>
